import { Link } from 'react-router-dom';
import PidStage from '../components/PidStage';
import { usePublicDemo } from '../hooks';
import { useMe } from '../../../hooks';
import { formatDate, formatDuration, formatRows } from '../../../shared/format';

export default function HistoryShowcase() {
  const me = useMe();
  const demo = usePublicDemo();
  const data = demo.data;
  const sample = data?.samples[data.samples.length - 1] ?? null;
  const loggedIn = Boolean(me.data);

  return (
    <div className="replay">
      <div className="replay-head">
        <div>
          <div className="eyebrow">History · Public Preview</div>
          <div className="replay-title">
            <h1>历史数据回放</h1>
          </div>
          <div className="replay-meta">
            {data ? (
              <>
                <span>{formatDate(data.dataset.startedAt)}</span>
                <span>{formatDuration(data.dataset.durationS)}</span>
                <span>{formatRows(data.dataset.rowCount)} 行</span>
                <span className="badge">演示数据</span>
              </>
            ) : (
              <span>公开演示数据集</span>
            )}
          </div>
        </div>
        <Link to="/ccs" className="btn btn-primary">
          {loggedIn ? '打开数据集列表' : '登录后播放全部数据'}
        </Link>
      </div>

      {demo.isLoading ? (
        <div className="empty">正在加载演示数据…</div>
      ) : data ? (
        <section className="panel pid-panel history-stage">
          <PidStage sample={sample} zoom={1} selected={null} onSelect={() => undefined} />
        </section>
      ) : (
        <div className="empty">
          <b>演示数据准备中</b>
          登录后可以查看全部历史数据。
        </div>
      )}

      <p className="caption">
        当前展示一条公开演示数据：系统图与最后一段采样。登录后可以选择任意数据集回放、调节倍速、发起演示房间。
      </p>
    </div>
  );
}